"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const Edit = (props) => {
    const { width, height, color } = props;
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height, viewBox: "0 0 32 32", "data-testID": "GasPump" },
        react_1.default.createElement(react_native_svg_1.G, { fill: "none", "fill-rule": "evenodd" },
            react_1.default.createElement(react_native_svg_1.Path, { d: "M0 .5h32v32H0z" }),
            react_1.default.createElement(react_native_svg_1.Path, { d: "M19 26.5V7.928c0-.831-.58-1.428-1.435-1.428h-8.13C8.579 6.5 8 7.097 8 7.928V26.5m12.5 0h-14m12.5-12H8m17.5-3L23 14.166V15.5h2.5m-6.5.834h.65c1.077 0 1.95.895 1.95 2V23c0 1.105.873 2 1.95 2s1.95-.895 1.95-2V11.666L22.9 9", stroke: color }))));
};
Edit.defaultProps = {
    color: '#111111',
    width: 32,
    height: 32,
};
exports.default = react_1.default.memo(Edit);
